import axios from "axios";

const apiClient = axios.create({
    baseURL: "https://api2.bpetroleum.kg",
});

export default apiClient;
